{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "update": "Update",
    "submit": "Submit",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "import": "Import",
    "download": "Download",
    "upload": "Upload",
    "retry": "Retry",
    "loading": "Loading",
    "view": "View",
    "copy": "Copy",
    "share": "Share",
    "print": "Print"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "completed": "Completed",
    "failed": "Failed",
    "succeeded": "Succeeded",
    "processing": "Processing",
    "draft": "Draft",
    "archived": "Archived",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "refunded": "Refunded",
    "disputed": "Disputed",
    "expired": "Expired"
  },
  "labels": {
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "amount": "Amount",
    "currency": "Currency",
    "date": "Date",
    "status": "Status",
    "actions": "Actions",
    "description": "Description",
    "notes": "Notes",
    "total": "Total",
    "subtotal": "Subtotal",
    "tax": "Tax",
    "fee": "Fee"
  },
  "errors": {
    "required": "This field is required",
    "invalidEmail": "Invalid email address",
    "network": "Network error",
    "generic": "Something went wrong",
    "notFound": "Not found",
    "unauthorized": "Unauthorized"
  },
  "pagination": {
    "showing": "Showing {{from}}-{{to}} of {{total}}",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "rowsPerPage": "Rows per page",
    "noResults": "No results",
    "previous": "Previous",
    "next": "Next"
  },
  "language": {
    "label": "Language",
    "en": "English"
  },
  "ui": {
    "CaptureFieldsEditor": {
      "customer_information_fields": "Customer Information Fields",
      "add_field": "Add Field",
      "field_type": "Field Type",
      "preset_field": "Preset Field",
      "custom_field": "Custom Field",
      "full_name": "Full Name",
      "email_address": "Email Address",
      "phone_number": "Phone Number",
      "billing_address": "Billing Address",
      "company_name": "Company Name",
      "field_label": "Field Label",
      "attrs": {
        "eg_project_name": "e.g., Project Name",
        "eg_please_provide_the_project_name": "e.g., Please provide the project name for your invoice"
      },
      "field_description_optional": "Field Description (Optional)",
      "required_field": "Required field",
      "no_capture_fields_added": "No capture fields added",
      "add_fields_to_collect_information_from": "Add fields to collect information from your customers",
      "these_fields_will_be_shown_on": "These fields will be shown on the payment page for customers to fill out\n        before completing their payment."
    },
    "LoadingScreen": {
      "attrs": {
        "pomelo": "Pomelo"
      },
      "loading_your_dashboard": "Loading your dashboard",
      "please_wait_a_moment": "Please wait a moment..."
    },
    "MetadataEditor": {
      "attrs": {
        "custom_metadata": "Custom metadata",
        "add_additional_data_to_track_with": "Add additional data to track with this payment",
        "key": "Key"
      },
      "preset_fields_are_configured_in_your": "Preset fields are configured in your settings and automatically\n                included in all payment links.",
      "required_preset_fields_cannot_be_removed": "Required preset fields cannot be removed. You can modify their\n                values but not their keys.",
      "add_custom_field": "Add custom field",
      "required": "Required"
    },
    "SearchableSelect": {
      "attrs": {
        "type_to_search": "Type to search..."
      },
      "no_results_found": "No results found"
    },
    "SuccessModal": {
      "done": "Done"
    },
    "TransactionFinancialBreakdown": {
      "attrs": {
        "recent_activity": "Recent activity",
        "financial_summary": "Financial summary",
        "gross_impact": "Gross impact",
        "fees_posted_incl_tax_where_applicable": "Fees (posted, incl. tax where applicable)",
        "fees_posted_ex_tax": "Fees (posted, ex tax)",
        "tax_on_fees_posted": "Tax on fees (posted)",
        "reserve_held": "Reserve held",
        "net_impact_posted_so_far": "Net impact (posted so far)",
        "paid_out": "Paid out",
        "scheduled_in_upcoming_payouts": "Scheduled in upcoming payouts",
        "held_in_reserve": "Held in reserve",
        "next_scheduled_payout": "Next scheduled payout",
        "view_fee_breakdown": "View fee breakdown",
        "payout_transfer_story": "Payout / transfer story",
        "fee_ex_tax": "Fee (ex tax)",
        "tax_on_fee": "Tax on fee",
        "total_fee_inc_tax": "Total fee (inc tax)"
      },
      "no_activity_recorded": "No activity recorded",
      "impact_on_merchant_balance": "Impact on merchant balance",
      "tax_display": "Tax display",
      "included": "Included",
      "separate": "Separate",
      "cash_movement": "Cash movement",
      "ledger_for_this_transaction": "Ledger for this transaction",
      "every_posting_that_affects_the_merchant": "Every posting that affects the merchant balance—payments, refunds,\n              disputes, fees, reserves, and reversals.",
      "export_csv": "Export CSV",
      "fee_tax_display": "Fee tax display:",
      "posting": "Posting",
      "gross": "Gross",
      "net_impact": "Net impact",
      "effective": "Effective",
      "settlement": "Settlement",
      "details": "Details",
      "posted": "Posted",
      "scheduled": "Scheduled",
      "postings": "postings",
      "no_scheduled_payouts": "No scheduled payouts",
      "held_now_releases": "Held now • Releases",
      "no_fee_details_available": "No fee details available.",
      "jurisdiction": "Jurisdiction",
      "display_mode": "Display mode:",
      "components": "Components",
      "ex_tax_tax": "Ex tax • Tax",
      "totals": "Totals"
    },
    "settlementUi": {
      "reserve": "Reserve",
      "releases": "Releases",
      "not_yet_included": "Not yet included"
    },
    "UniversalSearchBar": {
      "attrs": {
        "search_transactions_customers_invoices": "Search transactions, customers, invoices..."
      },
      "search_results": "Search Results (",
      "no_results_found_for": "No results found for \""
    }
  },
  "app": {
    "AppLayout": {
      "help": "Help",
      "notifications": "Notifications",
      "mark": "Mark",
      "as_read": "as read",
      "view_preferences": "View preferences",
      "unread": "Unread",
      "all": "All",
      "no_notifications": "No notifications",
      "of": "of",
      "unread_notifications": "unread notifications",
      "view_all": "View all",
      "invoice": "Invoice",
      "i": "I",
      "subscription": "Subscription",
      "s": "S",
      "payment_link": "Payment link",
      "l": "L",
      "charge": "Charge",
      "p": "P",
      "security_hold": "Security hold",
      "o": "O",
      "attrs": {
        "user_profile": "User profile"
      },
      "simon": "Simon",
      "account": "Account",
      "report": "Report",
      "settings": "Settings",
      "security": "Security",
      "logout": "Logout",
      "dashboard": "Dashboard",
      "merchants_partners": "Merchants & Partners",
      "payment_requests": "Payment requests",
      "terminals": "Terminals",
      "virtual": "Virtual",
      "physical": "Physical",
      "softpos": "SoftPos",
      "connect": "Connect",
      "invoices": "Invoices",
      "bills": "Bills",
      "relationships": "Relationships",
      "customers": "Customers",
      "suppliers": "Suppliers",
      "payments": "Payments",
      "balance": "Balance",
      "summary": "Summary",
      "activity": "Activity",
      "payouts": "Payouts",
      "transactions": "Transactions",
      "payment_analytics": "Payment analytics",
      "sales": "Sales",
      "disputes": "Disputes",
      "refunds": "Refunds",
      "ecommerce": "E-Commerce",
      "shops": "Shops",
      "orders": "Orders",
      "campaigns": "Campaigns",
      "reports_analytics": "Reports & Analytics",
      "reporting": "Reporting",
      "reports": "Reports",
      "custom_metrics": "Custom metrics",
      "nadi": "Nadi",
      "system": "System",
      "tutorials": "Tutorials",
      "assistant": "Assistant",
      "hi_im_pomelo_pay_assistant": "Hi, I'm your CIMB Assistant. 👋",
      "what_do_you_need_help_with": "What do you need help with? Select a topic or type your\n                    question below.",
      "recent": "RECENT",
      "how_do_i_enable_fpx_for": "How do I enable BML Connect for my customers?"
    }
  }
}
